import { render } from "./SmsOutbox.vue?vue&type=template&id=5beca2e2&scoped=true"
import script from "./SmsOutbox.vue?vue&type=script&lang=js"
export * from "./SmsOutbox.vue?vue&type=script&lang=js"

import "./SmsOutbox.vue?vue&type=style&index=0&id=5beca2e2&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5beca2e2"]])

export default __exports__